<div class="cd-overlay" *ngIf="dialog.state as s" (click)="dialog.close(false)">
  <div class="cd-box" role="alertdialog" aria-modal="true" [attr.aria-label]="s.message" (click)="$event.stopPropagation()">
    <p class="cd-message">{{ s.message }}</p>
    <div class="cd-actions">
      <ng-container *ngIf="s.kind === 'confirm'; else alertActions">
        <button type="button" class="cd-btn cd-btn--ghost" (click)="dialog.close(false)">{{ t('common.cancel', 'Отмена') }}</button>
        <button type="button" class="cd-btn" [class.cd-btn--danger]="s.danger" (click)="dialog.close(true)">
          {{ s.confirmText || (s.danger ? t('common.delete', 'Удалить') : t('common.confirm', 'Подтвердить')) }}
        </button>
      </ng-container>
      <ng-template #alertActions>
        <button type="button" class="cd-btn" (click)="dialog.close(true)">{{ t('common.ok', 'Понятно') }}</button>
      </ng-template>
    </div>
  </div>
</div>
